define("shared/components/shared/post/secondary/activity/wrapper", ["exports", "@ember/component", "@ember/object", "@ember/runloop", "@ember/service", "@glimmer/component", "later/models/post-activity", "later/utils/constants/segment-events", "shared/utils/uuid", "@ember/template-factory"], function (_exports, _component, _object, _runloop, _service, _component2, _postActivity, _segmentEvents, _uuid, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _sanitizeComment, _addDivider, _addComment, _addAction, _getUserName, _formatDividerDateTime, _formatDateTime, _isCreatedTimeToday, _formatActivityCreatedTime, _isNew;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@ember/service",0,"@glimmer/component",0,"later/models/post-activity",0,"later/utils/constants/segment-events",0,"shared/utils/uuid",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(receiver, privateSet, fn) { _assertClassBrand(privateSet, receiver); return fn; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    class="o--modalCard--secondary cAP--modalCard--secondary"
    data-test-id="activity-modal"
    {{did-insert this.updateView}}
  >
    <Shared::Post::Secondary::Activity::Header />
    <Shared::Post::Secondary::Activity::Body
      @formattedPostActivities={{this.formattedPostActivities}}
      @hasUnsavedChanges={{@hasUnsavedChanges}}
      @scrollbarId={{this.SCROLLBAR_ID}}
    />
    <Shared::Post::Secondary::Activity::Footer
      @post={{@post}}
      @saveComment={{this.saveComment}}
      @scrollbarId={{this.SCROLLBAR_ID}}
      @toggleActivityModal={{@toggleActivityModal}}
    />
  </div>
  */
  {
    "id": "MZX+j1P/",
    "block": "[[[11,0],[24,0,\"o--modalCard--secondary cAP--modalCard--secondary\"],[24,\"data-test-id\",\"activity-modal\"],[4,[38,0],[[30,0,[\"updateView\"]]],null],[12],[1,\"\\n  \"],[8,[39,1],null,null,null],[1,\"\\n  \"],[8,[39,2],null,[[\"@formattedPostActivities\",\"@hasUnsavedChanges\",\"@scrollbarId\"],[[30,0,[\"formattedPostActivities\"]],[30,1],[30,0,[\"SCROLLBAR_ID\"]]]],null],[1,\"\\n  \"],[8,[39,3],null,[[\"@post\",\"@saveComment\",\"@scrollbarId\",\"@toggleActivityModal\"],[[30,2],[30,0,[\"saveComment\"]],[30,0,[\"SCROLLBAR_ID\"]],[30,3]]],null],[1,\"\\n\"],[13]],[\"@hasUnsavedChanges\",\"@post\",\"@toggleActivityModal\"],false,[\"did-insert\",\"shared/post/secondary/activity/header\",\"shared/post/secondary/activity/body\",\"shared/post/secondary/activity/footer\"]]",
    "moduleName": "shared/components/shared/post/secondary/activity/wrapper.hbs",
    "isStrictMode": false
  });
  var FormattedPostActivityType = /*#__PURE__*/function (FormattedPostActivityType) {
    FormattedPostActivityType["Action"] = "action";
    FormattedPostActivityType["Comment"] = "comment";
    FormattedPostActivityType["Divider"] = "divider";
    return FormattedPostActivityType;
  }(FormattedPostActivityType || {});
  let WrapperComponent = _exports.default = (_class = (_sanitizeComment = /*#__PURE__*/new WeakSet(), _addDivider = /*#__PURE__*/new WeakSet(), _addComment = /*#__PURE__*/new WeakSet(), _addAction = /*#__PURE__*/new WeakSet(), _getUserName = /*#__PURE__*/new WeakSet(), _formatDividerDateTime = /*#__PURE__*/new WeakSet(), _formatDateTime = /*#__PURE__*/new WeakSet(), _isCreatedTimeToday = /*#__PURE__*/new WeakSet(), _formatActivityCreatedTime = /*#__PURE__*/new WeakSet(), _isNew = /*#__PURE__*/new WeakSet(), class WrapperComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _isNew);
      _classPrivateMethodInitSpec(this, _formatActivityCreatedTime);
      _classPrivateMethodInitSpec(this, _isCreatedTimeToday);
      _classPrivateMethodInitSpec(this, _formatDateTime);
      _classPrivateMethodInitSpec(this, _formatDividerDateTime);
      _classPrivateMethodInitSpec(this, _getUserName);
      _classPrivateMethodInitSpec(this, _addAction);
      _classPrivateMethodInitSpec(this, _addComment);
      _classPrivateMethodInitSpec(this, _addDivider);
      _classPrivateMethodInitSpec(this, _sanitizeComment);
      _defineProperty(this, "SCROLLBAR_ID", (0, _uuid.default)());
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "cache", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "locale", _descriptor5, this);
      _initializerDefineProperty(this, "segment", _descriptor6, this);
      _initializerDefineProperty(this, "perfectScroll", _descriptor7, this);
      _initializerDefineProperty(this, "store", _descriptor8, this);
    }
    get postActivities() {
      if (this.args.post.get('isNew')) {
        return this.args.post.get('postActivities');
      }
      return this.store.peekAll('post-activity').filter(postActivity => String(postActivity.postId) === this.args.post.id).sortBy('createdTime');
    }
    get formattedPostActivities() {
      const formattedPostActivities = [];
      if (this.postActivities && this.postActivities.firstObject && this.postActivities.lastObject) {
        // Always add a divider first
        formattedPostActivities.push(_classPrivateMethodGet(this, _addDivider, _addDivider2).call(this, this.postActivities.firstObject));
        const {
          lastObject
        } = this.postActivities;
        // Loop through activities and add formatted post activities
        this.postActivities.forEach((postActivity, index, self) => {
          if (postActivity.activityType === _postActivity.PostActivityType.Comment) {
            // Add comment
            formattedPostActivities.push(_classPrivateMethodGet(this, _addComment, _addComment2).call(this, postActivity));
          } else if (
          // Add action
          postActivity.activityType === _postActivity.PostActivityType.Submitted || postActivity.activityType === _postActivity.PostActivityType.Approved) {
            formattedPostActivities.push(_classPrivateMethodGet(this, _addAction, _addAction2).call(this, postActivity));
          }

          // Add divider if next item's date is different (except last item)
          const isLastObject = lastObject.id === postActivity.id;
          if (!isLastObject && _classPrivateMethodGet(this, _formatDividerDateTime, _formatDividerDateTime2).call(this).format(postActivity.adjustedCreatedTime) !== _classPrivateMethodGet(this, _formatDividerDateTime, _formatDividerDateTime2).call(this).format(self[index + 1].adjustedCreatedTime)) {
            formattedPostActivities.push(_classPrivateMethodGet(this, _addDivider, _addDivider2).call(this, self[index + 1]));
          }
        });
      }
      return formattedPostActivities;
    }
    get cacheKey() {
      if (this.args.post?.get('id')) {
        return `last_post_activity_read_${this.args.post.get('id')}`;
      }
      return undefined;
    }
    updateView() {
      this.perfectScroll.scrollToBottom(this.SCROLLBAR_ID);
      if (!this.args.post.get('isNew')) {
        (0, _runloop.later)(() => {
          if (this.cacheKey) {
            this.cache.add(this.cacheKey, Date.now(), {
              expiry: this.cache.maxExpiryDate(),
              persist: true
            });
          }
        }, 2400); // buffer for background animation to finish
      }
    }
    saveComment(comment) {
      const user = this.auth.currentUserModel;
      const postActivity = this.store.createRecord('post-activity', {
        activityType: _postActivity.PostActivityType.Comment,
        message: _classPrivateMethodGet(this, _sanitizeComment, _sanitizeComment2).call(this, comment),
        userName: user.name || user.email,
        createdTime: (Date.now() / 1000).toFixed(0),
        userId: user.id,
        postId: this.args.post.id
      });
      try {
        if (this.args.post.get('isNew')) {
          this.args.post.get('postActivities').pushObject(postActivity);
        } else {
          postActivity.save();
          this.segment.track(_segmentEvents.SegmentEventTypes.AddedCommentToPost, {
            post_id: this.args.post.id
          });
        }
      } catch (error) {
        this.errors.handleAdapter(error);
      }
      this.updateView();
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "perfectScroll", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "updateView", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveComment", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "saveComment"), _class.prototype)), _class);
  function _sanitizeComment2(comment) {
    // Removes html and white spaces
    return comment.replace(/<[^>]+>/g, '').trim();
  }
  function _addDivider2(postActivity) {
    return {
      type: FormattedPostActivityType.Divider,
      timestamp: _classPrivateMethodGet(this, _isCreatedTimeToday, _isCreatedTimeToday2).call(this, postActivity.adjustedCreatedTime) ? this.intl.t('shared_words.today') : _classPrivateMethodGet(this, _formatDividerDateTime, _formatDividerDateTime2).call(this).format(postActivity.adjustedCreatedTime)
    };
  }
  function _addComment2(postActivity) {
    return {
      type: FormattedPostActivityType.Comment,
      timestamp: _classPrivateMethodGet(this, _formatActivityCreatedTime, _formatActivityCreatedTime2).call(this, postActivity.adjustedCreatedTime),
      username: _classPrivateMethodGet(this, _getUserName, _getUserName2).call(this, postActivity),
      content: postActivity.message,
      isNew: _classPrivateMethodGet(this, _isNew, _isNew2).call(this, postActivity.adjustedCreatedTime)
    };
  }
  function _addAction2(postActivity) {
    return {
      type: FormattedPostActivityType.Action,
      timestamp: _classPrivateMethodGet(this, _formatActivityCreatedTime, _formatActivityCreatedTime2).call(this, postActivity.adjustedCreatedTime),
      username: _classPrivateMethodGet(this, _getUserName, _getUserName2).call(this, postActivity),
      content: postActivity.activityType,
      isNew: _classPrivateMethodGet(this, _isNew, _isNew2).call(this, postActivity.adjustedCreatedTime)
    };
  }
  function _getUserName2(postActivity) {
    const user = this.store.peekRecord('user', postActivity.userId);
    return user?.name || postActivity.userName || user?.email || user?.id || '';
  }
  function _formatDividerDateTime2() {
    return new Intl.DateTimeFormat(this.locale.primaryLocale, {
      month: 'short',
      day: '2-digit'
    });
  }
  function _formatDateTime2() {
    return new Intl.DateTimeFormat(this.locale.primaryLocale, {
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }
  function _isCreatedTimeToday2(createdTime) {
    return _classPrivateMethodGet(this, _formatDividerDateTime, _formatDividerDateTime2).call(this).format(createdTime) === _classPrivateMethodGet(this, _formatDividerDateTime, _formatDividerDateTime2).call(this).format(Date.now());
  }
  function _formatActivityCreatedTime2(createdTime) {
    if (_classPrivateMethodGet(this, _isCreatedTimeToday, _isCreatedTimeToday2).call(this, createdTime)) {
      const relativeTime = this.locale.formatRelativeTime(createdTime) || _classPrivateMethodGet(this, _formatDateTime, _formatDateTime2).call(this).format(createdTime);
      return relativeTime;
    }
    return _classPrivateMethodGet(this, _formatDateTime, _formatDateTime2).call(this).format(createdTime);
  }
  function _isNew2(createdTime) {
    if (this.args.post.get('isNew')) {
      return false;
    }
    const lastUnreadPostActivity = this.cacheKey ? this.cache.retrieve(this.cacheKey) : undefined;
    if (!lastUnreadPostActivity) {
      return true;
    }
    return createdTime > Number(lastUnreadPostActivity);
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, WrapperComponent);
});